var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import SunEditor from 'suneditor-react';
import './HtmlEditor2.css';
import './suneditor.css';
import React, { useState } from 'react';
import { defaultButtonList, defaultColorList, defaultFontSizes } from './constants';
var RED_BORDER = '2px solid var(--red)';
var BLUE_BORDER = '2px solid var(--blue)';
var TRANSPARENT_BORDER = '2px solid transparent';
var HtmlEditor2 = function (_a) {
    var name = _a.name, onChange = _a.onChange, onBlur = _a.onBlur, defaultValue = _a.defaultValue, _b = _a.placeholder, placeholder = _b === void 0 ? 'Введите ваш текст...' : _b, _c = _a.isValid, isValid = _c === void 0 ? true : _c, validationMessage = _a.validationMessage, editorOptions = _a.editorOptions, _d = _a.fontSize, fontSize = _d === void 0 ? defaultFontSizes : _d, _e = _a.colorList, colorList = _e === void 0 ? defaultColorList : _e, _f = _a.buttonList, buttonList = _f === void 0 ? defaultButtonList : _f, editorProps = __rest(_a, ["name", "onChange", "onBlur", "defaultValue", "placeholder", "isValid", "validationMessage", "editorOptions", "fontSize", "colorList", "buttonList"]);
    var _g = __read(useState(TRANSPARENT_BORDER), 2), borderStyle = _g[0], setBorderStyle = _g[1];
    var options = __assign({ height: '150px', fontSize: fontSize, colorList: colorList, buttonList: buttonList, pasteTagsBlacklist: '(span)', defaultStyle: 'overflow: auto; font-family: var(--font-normal); font-size: 18px' }, editorOptions);
    var wrapStyle = {
        fontFamily: 'var(--font-normal)',
        border: isValid ? borderStyle : RED_BORDER,
        position: 'relative',
        zIndex: 2,
        margin: 'auto',
        pointerEvents: 'auto',
        boxSizing: 'border-box',
        borderRadius: '3px'
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: wrapStyle },
            React.createElement(SunEditor, __assign({ onChange: onChange, defaultValue: defaultValue, onBlur: function () {
                    setBorderStyle(TRANSPARENT_BORDER), onBlur && onBlur();
                }, onFocus: function () {
                    setBorderStyle(BLUE_BORDER);
                }, placeholder: placeholder, name: name, lang: 'ru', setOptions: options }, editorProps))),
        isValid ? (React.createElement("span", { style: { fontSize: '16px', visibility: 'hidden' } }, '\u00A0')) : (React.createElement("span", { style: { color: 'var(--red)', fontSize: '16px' } }, validationMessage))));
};
export default React.memo(HtmlEditor2);
